export default __webpack_public_path__ + "static/heroIcon1-8101756c6b490609491258cf3cc24c9f.svg";